import { useQuery } from 'react-query';

import { queryKeys } from 'src/services/api/constants';
import { apiClient } from 'src/services/api/client';
import { GET_USER_STREAKS_PATH } from 'src/services/api/streaks/constants';
import type { IGetUserStreaksResponse } from 'src/services/api/streaks/types';

export const useUserStreaks = () => {
    return useQuery(
        [queryKeys.userStreaks],
        async () => {
            const res = await apiClient(GET_USER_STREAKS_PATH).json<IGetUserStreaksResponse>();
            return res.user_streak;
        }
    );
};
